import instanceService from "./instance";
import {DIRECTORIES_URL} from "../helpers/constants";

let instance = instanceService.instance(DIRECTORIES_URL)

export const directoriesService = {
    getIndexTerrorist,
    getIndexSoato,
    getIndexIssuingAuthority,
    getIndexSoatoZip,
    getIndexIssuingAuthorityZip
}

function getIndexTerrorist(data) {
    const formData = new FormData()
    formData.append('file', data)
    const options = {
        method: 'POST',
        data: formData,
        url: '/load'
    }
    return instance(options)
}

function getIndexSoatoZip(data) {
    const formData = new FormData()
    formData.append('file', data)
    const options = {
        method: 'POST',
        data: formData,
        url: '/index/zip/addresses'
    }
    return instance(options)
}

function getIndexIssuingAuthorityZip(data) {
    const formData = new FormData()
    formData.append('file', data)
    const options = {
        method: 'POST',
        data: formData,
        url: '/index/zip/authority'
    }
    return instance(options)
}

function getIndexSoato() {
    const options = {
        method: 'POST',
        data: {},
        url: '/index/addresses'
    }
    return instance(options)
}

function getIndexIssuingAuthority() {
    const options = {
        method: 'POST',
        data: {},
        url: '/index/authority'
    }
    return instance(options)
}